import React, { useState, useEffect } from 'react'
import { postsAPI, categoriesAPI } from '../services/api'
import './Dashboard.css'

interface DashboardStats {
  totalPosts: number
  publishedPosts: number
  draftPosts: number
  totalCategories: number
}

const Dashboard: React.FC = () => {
  const [stats, setStats] = useState<DashboardStats>({
    totalPosts: 0,
    publishedPosts: 0,
    draftPosts: 0,
    totalCategories: 0,
  })
  const [recentPosts, setRecentPosts] = useState<any[]>([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    loadDashboardData()
  }, [])

  const loadDashboardData = async () => {
    try {
      // Load posts stats
      const [allPosts, publishedPosts, draftPosts, categories] = await Promise.all([
        postsAPI.getAll({ limit: 100 }),
        postsAPI.getAll({ status: 'published', limit: 100 }),
        postsAPI.getAll({ status: 'draft', limit: 100 }),
        categoriesAPI.getAll(),
      ])

      setStats({
        totalPosts: allPosts.pagination?.total || allPosts.posts?.length || 0,
        publishedPosts: publishedPosts.pagination?.total || publishedPosts.posts?.length || 0,
        draftPosts: draftPosts.pagination?.total || draftPosts.posts?.length || 0,
        totalCategories: categories.categories?.length || 0,
      })

      // Get recent posts
      const recent = await postsAPI.getAll({ limit: 5 })
      setRecentPosts(recent.posts || [])
    } catch (error) {
      console.error('Failed to load dashboard data:', error)
    } finally {
      setIsLoading(false)
    }
  }

  if (isLoading) {
    return <div className="loading">Đang tải...</div>
  }

  return (
    <div className="dashboard">
      <div className="dashboard-header">
        <h2>Tổng quan</h2>
        <p>Chào mừng bạn đến với trang quản trị Báo Chính Phủ</p>
      </div>

      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-icon">📊</div>
          <div className="stat-content">
            <h3>{stats.totalPosts}</h3>
            <p>Tổng bài viết</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">✅</div>
          <div className="stat-content">
            <h3>{stats.publishedPosts}</h3>
            <p>Đã xuất bản</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">📝</div>
          <div className="stat-content">
            <h3>{stats.draftPosts}</h3>
            <p>Bản nháp</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">📁</div>
          <div className="stat-content">
            <h3>{stats.totalCategories}</h3>
            <p>Danh mục</p>
          </div>
        </div>
      </div>

      <div className="recent-posts">
        <h3>Bài viết gần đây</h3>
        <div className="posts-list">
          {recentPosts.length > 0 ? (
            recentPosts.map((post) => (
              <div key={post.id} className="post-item">
                <div className="post-info">
                  <h4>{post.title}</h4>
                  <p>
                    Tác giả: {post.author_name} | Danh mục: {post.category_name}
                  </p>
                  <span className={`status ${post.status}`}>
                    {post.status === 'published' ? 'Đã xuất bản' : 
                     post.status === 'draft' ? 'Bản nháp' : 'Lưu trữ'}
                  </span>
                </div>
                <div className="post-meta">
                  <small>{new Date(post.created_at).toLocaleDateString('vi-VN')}</small>
                </div>
              </div>
            ))
          ) : (
            <p>Chưa có bài viết nào</p>
          )}
        </div>
      </div>
    </div>
  )
}

export default Dashboard